export default {
	init() {
		const layouts = document.querySelectorAll('.layout.listing.listing-faq.has-category-nav');
		if (!layouts.length) return;

		layouts.forEach((layout) => {
			const nav = layout.querySelector('.faq-category-nav');
			if (!nav) return;

			const links = Array.from(nav.querySelectorAll('.faq-category-nav-link'));
			if (!links.length) return;

			const linkById = new Map();
			links.forEach((link) => {
				const href = link.getAttribute('href') || '';
				if (!href.startsWith('#')) return;
				const id = href.slice(1);
				if (!id) return;
				linkById.set(id, link);
			});

			function setActive(targetId) {
				if (!targetId) return;
				links.forEach((link) => {
					link.classList.remove('is-active');
					link.removeAttribute('aria-current');
				});
				const active = linkById.get(targetId);
				if (active) {
					active.classList.add('is-active');
					active.setAttribute('aria-current', 'true');
				}
			}

			// Click sets active immediately.
			links.forEach((link) => {
				link.addEventListener('click', (event) => {
					const href = link.getAttribute('href') || '';
					if (!href.startsWith('#')) return;

					const targetId = href.slice(1);
					if (!targetId) return;

					const targetEl = layout.querySelector(`#${CSS.escape(targetId)}`);
					if (!targetEl) return;

					event.preventDefault();

					const offsetPx = 100;
					const top =
						targetEl.getBoundingClientRect().top + window.pageYOffset - offsetPx;

					const prefersReducedMotion =
						window.matchMedia &&
						window.matchMedia('(prefers-reduced-motion: reduce)').matches;

					window.scrollTo({
						top: Math.max(0, top),
						behavior: prefersReducedMotion ? 'auto' : 'smooth',
					});

					// Keep URL hash in sync without relying on the browser's default anchor jump.
					if (history && history.pushState) {
						history.pushState(null, '', `#${targetId}`);
					} else {
						window.location.hash = `#${targetId}`;
					}

					setActive(targetId);
				});
			});

			// Hash change (keyboard nav / manual edit).
			window.addEventListener('hashchange', () => {
				const id = (window.location.hash || '').replace('#', '');
				if (id) setActive(id);
			});

			// Scroll spy using IntersectionObserver.
			const targets = Array.from(linkById.keys())
				.map((id) => layout.querySelector(`#${CSS.escape(id)}`))
				.filter(Boolean);

			if ('IntersectionObserver' in window && targets.length) {
				const observer = new IntersectionObserver(
					(entries) => {
						// Pick the first visible entry closest to the top.
						const visible = entries
							.filter((e) => e.isIntersecting && e.target && e.target.id)
							.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
						if (visible.length) setActive(visible[0].target.id);
					},
					{
						root: null,
						rootMargin: '-25% 0px -65% 0px',
						threshold: [0, 0.1, 0.2, 0.3],
					}
				);

				targets.forEach((el) => observer.observe(el));
			}

			// Initial state.
			const initial = (window.location.hash || '').replace('#', '');
			if (initial && linkById.has(initial)) {
				setActive(initial);
			} else {
				const first = links[0].getAttribute('href') || '';
				if (first.startsWith('#')) setActive(first.slice(1));
			}
		});
	},
};
